/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalReauthDocumentSelectionRequest
 */
export interface PalReauthDocumentSelectionRequest {
    /**
     * 
     */
    is_selected: boolean;
}

/**
 * Check if a given object implements the PalReauthDocumentSelectionRequest interface.
 */
export function instanceOfPalReauthDocumentSelectionRequest(value: object): value is PalReauthDocumentSelectionRequest {
    if (!('is_selected' in value) || value['is_selected'] === undefined) return false;
    return true;
}

export function PalReauthDocumentSelectionRequestFromJSON(json: any): PalReauthDocumentSelectionRequest {
    return PalReauthDocumentSelectionRequestFromJSONTyped(json, false);
}

export function PalReauthDocumentSelectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthDocumentSelectionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'is_selected': json['is_selected'],
    };
}

export function PalReauthDocumentSelectionRequestToJSON(json: any): PalReauthDocumentSelectionRequest {
    return PalReauthDocumentSelectionRequestToJSONTyped(json, false);
}

export function PalReauthDocumentSelectionRequestToJSONTyped(value?: PalReauthDocumentSelectionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_selected': value['is_selected'],
    };
}

